import {HtmlPreview} from '@/shared-components/HtmlPreview'
import {EmailTemplateStepType} from '@/types/NotificationStep'
import {useIntl} from 'react-intl'

interface Props {
  notificationTypeName: string
  emailStep: EmailTemplateStepType
}

export default function NotificationEmailTemplateDetails({notificationTypeName, emailStep}: Props) {
  const {formatMessage} = useIntl()
  return (
    <div data-testid="notification-email-details" className="mt-2 rounded-lg border border-dashed border-blue-500 p-4">
      <div className="mt-8 text-base font-bold text-text-primary">
        {formatMessage({id: 'NOTIFICATION_DETAILS.NOTIFICATION_DETAILS_SECTION_TITLE'})}
      </div>
      <div className="border-b border-border-gray">
        <div className="pt-3 text-xs font-bold text-text-secondary">
          {formatMessage({id: 'NOTIFICATION_DETAILS.NOTIFICATION_TYPE'})}
        </div>
        <div className="pb-3 pt-1 text-xs text-text-primary">{notificationTypeName}</div>
      </div>
      <div className="border-b border-border-gray">
        <div className="pt-3 text-xs font-bold text-text-secondary">
          {formatMessage({id: 'NOTIFICATION_BUILDER.SUBJECT_LABEL'})}
        </div>
        <div className="pb-3 pt-1 text-xs text-text-primary">{emailStep.emailSubject}</div>
      </div>
      <div>
        <div className="border-b border-border-gray">
          <div className="pt-3 text-xs font-bold text-text-secondary">
            {formatMessage({id: 'NOTIFICATION_DETAILS.TEMPLATE_SELECTED'})}
          </div>
          <div className="pb-3 pt-1 text-xs text-text-primary">{emailStep.name}</div>
        </div>
        <div className="pt-3">
          <HtmlPreview html={emailStep.html} data-testid="notification-email-template-preview" />
        </div>
      </div>
    </div>
  )
}
